var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isSkills
        ? _c("skills", {
            ref: "skills",
            attrs: {
              form: _vm.form.skills.data,
              field: _vm.field,
              "field-type": _vm.fieldType,
            },
            on: {
              editDictionary: function ($event) {
                return _vm.$emit("editDictionary", $event)
              },
            },
          })
        : _vm._e(),
      _vm.isCareer
        ? _c("career", {
            ref: "career",
            attrs: {
              form: _vm.form.career.data,
              field: _vm.field,
              "field-type": _vm.fieldType,
            },
            on: {
              editDictionary: function ($event) {
                return _vm.$emit("editDictionary", $event)
              },
            },
          })
        : _vm._e(),
      _vm.isPersonalData
        ? _c("personal-data", {
            ref: "personalData",
            attrs: {
              form: _vm.form.personalData.data,
              field: _vm.field,
              "field-type": _vm.fieldType,
            },
            on: {
              editDictionary: function ($event) {
                return _vm.$emit("editDictionary", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }